import { firestoreAction } from 'vuexfire';
import { db } from '@/plugins/firebaseDB';

const initialState = {
  users: [],
};

const getters = {
  getUsers: state => state.users,
  getUser: state => index => state.users.find(user => user.id === index),
};

const mutations = {
  createUser: (state, user) => {
    db.collection('users').add(user);
  },
  updateUser: (state, user) => {
    db.collection('users').doc(user.id).update(user);
  },
  deleteUser: (state, user) => {
    db.collection('users').doc(user.id).delete();
  },
};

const actions = {
  // return the promise returned by `bindFirestoreRef`
  bindUsers: firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('users', db.collection('users').orderBy('email'))),
  createUser: (context, user) => {
    context.commit('createUser', user);
  },
  updateUser: (context, user) => {
    context.commit('updateUser', user);
  },
  deleteUser: (context, user) => {
    context.commit('deleteUser', user);
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  getters,
};
